import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/api-endpoints';
import { Upload } from 'src/models/upload';
import { AppResponse } from 'src/models/app-response';
import { HOST_API } from 'src/config-global';
import urlJoin from "url-join";

// ----------------------------------------------------------------------

export async function uploadFile(files: FileList): Promise<AppResponse<Upload[]>> {
  const URL = endpoints.upload.uploadFile;
  try {
    const formData = new FormData();
    Array.from(files).forEach((file) => formData.append('upload', file));
    const response = await axios.post(URL, formData);
    return response.data;
  } catch (error) {
    console.error('Failed to upload file:', error);
    throw error;
  }
}

export async function uploadFileAttachments(formData: FormData): Promise<string[]> {
  const URL = endpoints.upload.uploadFile;
  try {
    const response = await axios.post<AppResponse<string[]>>(URL, formData);
    if (response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    throw new Error('Invalid response structure');
  } catch (error) {
    throw new Error('Failed to upload files');
  }
}

export async function uploadImage(file: File): Promise<AppResponse<string>> {
  const URL = endpoints.upload.uploadFile;
  try {
    const formData = new FormData();
    formData.append('upload', file);

    const response = await axios.post(URL, formData);
    return response.data;
  } catch (error) {
    console.error('Failed to upload image:', error);
    throw error;
  }
}

// export function getImageById(fileId: string): string {
//   return `${HOST_API}/${endpoints.upload.getFileById(fileId)}`;
// }

export function getImageById(fileId: string): string {
  return urlJoin(HOST_API, endpoints.upload.getFileById(fileId));
}

export function getThumbnailById(fileId: string): string {
  return `${HOST_API}/${endpoints.upload.getThumbnailById(fileId)}`;
}

export async function getFileById(fileId: string): Promise<File> {
  const URL = endpoints.upload.getFileById(fileId);
  try {
    const response = await axios.get(URL, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Failed to get file:', error);
    throw error;
  }
}

export async function deleteFile(fileId: string): Promise<AppResponse<Upload>> {
  const URL = `${endpoints.upload.deleteFile}/${fileId}`;
  try {
    const response = await axios.delete(URL);
    return response.data;
  } catch (error) {
    console.error('Failed to delete file:', error);
    throw error;
  }
}
